export const siteStats = [
  { label: '片库条目', value: '12,800+' },
  { label: '电视剧集', value: '3,260+' },
  { label: '免费专区', value: '2,140+' },
  { label: '每周更新', value: '90+' },
];

export const genres = [
  '全部',
  '动作',
  '科幻',
  '悬疑',
  '剧情',
  '爱情',
  '喜剧',
  '奇幻',
  '动画',
  '战争',
  '冒险',
];

export const kindTabs = ['全部', '电影', '剧集'];

export const movieCatalog = [
  {
    id: 'mp-01',
    title: '星海回响',
    kind: 'movie',
    genre: '科幻',
    region: '中国大陆',
    year: '2025',
    rating: '9.1',
    duration: '138分钟',
    tags: ['太空', '硬科幻', '人性'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20lone%20astronaut%20drifting%20before%20a%20vast%20amber%20nebula%2C%20dramatic%20rim%20lighting%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20textured%20film%20grain%2C%20dark%20studio%20background%20with%20soft%20glow%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-01&orientation=portrait',
    blurb: '一支深空救援队收到来自废弃空间站的信号，由此揭开一段被遗忘的人类往事。',
    free: false,
    featured: true,
  },
  {
    id: 'mp-02',
    title: '长安夜行录',
    kind: 'tv',
    genre: '悬疑',
    region: '中国大陆',
    year: '2025',
    rating: '8.9',
    duration: '全32集',
    tags: ['古装', '探案', '群像'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20an%20ancient%20chinese%20city%20at%20night%20with%20hanging%20crimson%20lanterns%20and%20a%20lone%20cloaked%20figure%2C%20misty%20streets%2C%20warm%20gold%20light%2C%20textured%20film%20grain%2C%20dark%20atmospheric%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-02&orientation=portrait',
    blurb: '灯会之夜接连发生离奇命案，三位身份迥异的查案人被迫联手。',
    free: false,
    featured: true,
  },
  {
    id: 'mp-03',
    title: '归途列车',
    kind: 'movie',
    genre: '剧情',
    region: '中国大陆',
    year: '2024',
    rating: '8.7',
    duration: '124分钟',
    tags: ['家庭', '公路', '治愈'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20warm%20sunset%20seen%20through%20a%20train%20window%20with%20a%20child%20silhouette%2C%20amber%20and%20copper%20tones%2C%20soft%20film%20grain%2C%20nostalgic%20mood%2C%20dark%20minimal%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-03&orientation=portrait',
    blurb: '一列横穿南北的绿皮火车上，一对父女用二十个小时重新认识了彼此。',
    free: true,
    featured: true,
  },
  {
    id: 'mp-04',
    title: '雾都追踪',
    kind: 'tv',
    genre: '悬疑',
    region: '中国大陆',
    year: '2024',
    rating: '8.6',
    duration: '全24集',
    tags: ['犯罪', '推理', '双男主'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20foggy%20city%20alley%20at%20dawn%20with%20a%20lone%20detective%20in%20a%20long%20coat%2C%20warm%20amber%20street%20lamp%20glow%2C%20moody%20noir%20tones%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-04&orientation=portrait',
    blurb: '十年悬案重启，老刑警与新法医在浓雾之城追查同一串脚印。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-05',
    title: '山海奇缘',
    kind: 'movie',
    genre: '动画',
    region: '中国大陆',
    year: '2025',
    rating: '8.8',
    duration: '96分钟',
    tags: ['国风', '冒险', '合家欢'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20poster%20art%20of%20mythical%20floating%20mountains%20and%20a%20giant%20glowing%20bird%2C%20warm%20gold%20and%20crimson%20palette%2C%20ink%20painting%20texture%2C%20soft%20film%20grain%2C%20dark%20dramatic%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-05&orientation=portrait',
    blurb: '少年为寻找失踪的守护神兽，踏上穿越上古山海的奇幻旅途。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-06',
    title: '春日慢歌',
    kind: 'movie',
    genre: '爱情',
    region: '中国大陆',
    year: '2024',
    rating: '8.2',
    duration: '112分钟',
    tags: ['文艺', '治愈', '都市'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20blossoming%20spring%20street%20with%20two%20soft%20silhouettes%20walking%20apart%2C%20warm%20peach%20and%20amber%20light%2C%20delicate%20film%20grain%2C%20dreamy%20minimal%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-06&orientation=portrait',
    blurb: '两个在唱片店相遇的陌生人，用一整个春天交换彼此的歌单。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-07',
    title: '极地防线',
    kind: 'movie',
    genre: '战争',
    region: '中国大陆',
    year: '2025',
    rating: '8.5',
    duration: '146分钟',
    tags: ['战争', '群像', '热血'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20soldiers%20holding%20a%20snowy%20ridge%20line%20at%20dusk%2C%20warm%20amber%20fires%20against%20cold%20blue%20snow%2C%20dramatic%20lighting%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-07&orientation=portrait',
    blurb: '风雪封锁的边境哨所里，一支小分队坚守着最后一条补给线。',
    free: false,
    featured: true,
  },
  {
    id: 'mp-08',
    title: '深夜食光',
    kind: 'tv',
    genre: '剧情',
    region: '中国大陆',
    year: '2025',
    rating: '8.4',
    duration: '全16集',
    tags: ['美食', '治愈', '单元'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20cozy%20late%20night%20diner%20with%20warm%20hanging%20lamp%20and%20rising%20steam%2C%20amber%20and%20copper%20tones%2C%20intimate%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-08&orientation=portrait',
    blurb: '只在凌晨营业的小馆子，每一道菜背后都藏着一位客人的故事。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-09',
    title: '光影之城',
    kind: 'tv',
    genre: '剧情',
    region: '中国大陆',
    year: '2024',
    rating: '8.3',
    duration: '全28集',
    tags: ['职场', '影视', '成长'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20vintage%20film%20studio%20with%20a%20camera%20and%20warm%20spotlights%2C%20golden%20dust%20in%20the%20air%2C%20amber%20tones%2C%20textured%20film%20grain%2C%20dark%20dramatic%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-09&orientation=portrait',
    blurb: '一群追梦的年轻人，在片场灯光与暗影之间寻找自己的位置。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-10',
    title: '无声证人',
    kind: 'movie',
    genre: '悬疑',
    region: '中国大陆',
    year: '2025',
    rating: '8.9',
    duration: '130分钟',
    tags: ['法庭', '犯罪', '反转'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20lone%20silhouette%20standing%20in%20a%20dramatic%20courtroom%20light%20beam%2C%20warm%20crimson%20accents%2C%20high%20contrast%20chiaroscuro%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-10&orientation=portrait',
    blurb: '一桩没有目击者的旧案，因一段意外录下的音频重新开庭。',
    free: false,
    featured: true,
  },
  {
    id: 'mp-11',
    title: '追风者计划',
    kind: 'movie',
    genre: '动作',
    region: '中国大陆',
    year: '2025',
    rating: '8.0',
    duration: '118分钟',
    tags: ['赛车', '科幻', '爽片'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20futuristic%20racing%20car%20streaking%20through%20a%20neon%20amber%20tunnel%20with%20motion%20blur%2C%20warm%20gold%20and%20crimson%20streaks%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-11&orientation=portrait',
    blurb: '传奇怪兽车手组建的极限车队，在一场没有规则的地下赛中全员回归。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-12',
    title: '江南旧梦',
    kind: 'tv',
    genre: '爱情',
    region: '中国大陆',
    year: '2023',
    rating: '8.1',
    duration: '全36集',
    tags: ['年代', '民国', '虐恋'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20misty%20jiangnan%20water%20town%20with%20stone%20bridge%20and%20warm%20lantern%20reflections%2C%20amber%20and%20sepia%20tones%2C%20nostalgic%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-12&orientation=portrait',
    blurb: '民国年间的江南水乡，一封信牵起两家半生的纠葛与守望。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-13',
    title: '荒野信标',
    kind: 'movie',
    genre: '冒险',
    region: '中国大陆',
    year: '2024',
    rating: '8.3',
    duration: '121分钟',
    tags: ['生存', '自然', '硬核'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20lone%20traveler%20beside%20a%20campfire%20in%20a%20vast%20desert%20under%20a%20starry%20sky%2C%20warm%20amber%20firelight%20against%20deep%20shadow%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-13&orientation=portrait',
    blurb: '迷失无人区的徒步者，依靠一枚老旧信标一点点找回生路。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-14',
    title: '王牌调解员',
    kind: 'tv',
    genre: '喜剧',
    region: '中国大陆',
    year: '2024',
    rating: '7.9',
    duration: '全30集',
    tags: ['律政', '轻喜剧', '群像'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20quirky%20bright%20office%20with%20stacked%20documents%20and%20a%20playful%20silhouette%2C%20warm%20amber%20and%20cream%20palette%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-14&orientation=portrait',
    blurb: '社区调解室里什么奇葩纠纷都有，而她的目标只有一个：把话说开。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-15',
    title: '记忆碎片铺',
    kind: 'movie',
    genre: '科幻',
    region: '中国大陆',
    year: '2025',
    rating: '8.6',
    duration: '116分钟',
    tags: ['记忆', '悬疑', '软科幻'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20shattered%20mirror%20reflecting%20a%20glowing%20amber%20face%20in%20fragments%2C%20surreal%20mood%2C%20warm%20gold%20light%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-15&orientation=portrait',
    blurb: '一家可以买卖记忆的小店，让一位顾客开始怀疑自己的过去。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-16',
    title: '小镇棋局',
    kind: 'movie',
    genre: '悬疑',
    region: '中国大陆',
    year: '2023',
    rating: '8.4',
    duration: '108分钟',
    tags: ['小镇', '群像', '暗线'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20an%20overhead%20view%20of%20a%20wooden%20chessboard%20with%20a%20single%20glowing%20piece%2C%20moody%20warm%20amber%20light%2C%20strategic%20tension%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-16&orientation=portrait',
    blurb: '一场普通的镇民大会，背后却是一盘下了十年的棋。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-17',
    title: '逆光而来',
    kind: 'movie',
    genre: '剧情',
    region: '中国大陆',
    year: '2024',
    rating: '7.8',
    duration: '105分钟',
    tags: ['青春', '励志', '运动'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20teenage%20runner%20backlit%20by%20a%20huge%20warm%20sunset%2C%20long%20shadow%20on%20an%20open%20track%2C%20golden%20amber%20tones%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-17&orientation=portrait',
    blurb: '被伤病终结职业生涯的少年，换了一条跑道重新出发。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-18',
    title: '龙脊山下',
    kind: 'movie',
    genre: '战争',
    region: '中国大陆',
    year: '2025',
    rating: '8.7',
    duration: '152分钟',
    tags: ['历史', '战争', '史诗'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20stone%20mountain%20fortress%20with%20crimson%20war%20banners%20at%20sunset%2C%20dramatic%20golden%20light%2C%20epic%20scale%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-18&orientation=portrait',
    blurb: '传说中不可攻破的关隘，在一场大雾里迎来了它最后的一战。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-19',
    title: '深海来信',
    kind: 'movie',
    genre: '科幻',
    region: '中国大陆',
    year: '2024',
    rating: '8.5',
    duration: '113分钟',
    tags: ['深海', '温情', '亲情'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20deep%20sea%20diver%20lit%20by%20a%20single%20warm%20amber%20beam%20in%20dark%20water%2C%20mysterious%20calm%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-19&orientation=portrait',
    blurb: '深海钻井平台上，一段被困海底的语音，改变了所有人的航向。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-20',
    title: '末班地铁',
    kind: 'movie',
    genre: '悬疑',
    region: '中国大陆',
    year: '2025',
    rating: '7.9',
    duration: '99分钟',
    tags: ['惊悚', '密闭', '反转'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20an%20empty%20subway%20platform%20at%20midnight%20with%20flickering%20warm%20light%20and%20long%20shadows%2C%20eerie%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-20&orientation=portrait',
    blurb: '每晚只在零点零三分出现的那班地铁，载着一车不敢回家的人。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-21',
    title: '花开巷陌',
    kind: 'tv',
    genre: '剧情',
    region: '中国大陆',
    year: '2023',
    rating: '8.0',
    duration: '全40集',
    tags: ['家庭', '治愈', '生活流'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20cozy%20old%20alley%20lined%20with%20blooming%20flowers%20and%20warm%20windows%2C%20amber%20and%20soft%20cream%20tones%2C%20homely%20nostalgic%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-21&orientation=portrait',
    blurb: '一条老巷子、四户人家，用四季的柴米油盐串起寻常日子。',
    free: true,
    featured: false,
  },
  {
    id: 'mp-22',
    title: '铁血航线',
    kind: 'movie',
    genre: '动作',
    region: '中国大陆',
    year: '2025',
    rating: '8.2',
    duration: '134分钟',
    tags: ['军事', '动作', '热血'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20warship%20cutting%20through%20rough%20seas%20under%20a%20burning%20amber%20sky%2C%20dramatic%20waves%2C%20crimson%20accents%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-22&orientation=portrait',
    blurb: '一支护航编队在风暴与暗流中，完成一次几乎不可能的任务。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-23',
    title: '幻夜歌剧院',
    kind: 'movie',
    genre: '奇幻',
    region: '中国大陆',
    year: '2024',
    rating: '8.6',
    duration: '127分钟',
    tags: ['歌剧', '幻境', '悬疑'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20grand%20opera%20house%20with%20deep%20crimson%20curtains%20and%20a%20masked%20singer%20in%20warm%20spotlight%2C%20golden%20dust%20motes%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-23&orientation=portrait',
    blurb: '剧院首演之夜，舞台上的幻象开始与台下的现实彼此渗透。',
    free: false,
    featured: false,
  },
  {
    id: 'mp-24',
    title: '时光邮局',
    kind: 'movie',
    genre: '爱情',
    region: '中国大陆',
    year: '2023',
    rating: '8.1',
    duration: '110分钟',
    tags: ['奇幻', '治愈', '时间'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20vintage%20post%20office%20counter%20piled%20with%20old%20letters%20and%20a%20warm%20brass%20lamp%2C%20amber%20and%20sepia%20tones%2C%20tender%20nostalgic%20mood%2C%20textured%20film%20grain%2C%20dark%20background%2C%20high%20detail%20editorial%20illustration&width=600&height=900&seq=mp-24&orientation=portrait',
    blurb: '一间能寄信给过去的小邮局，让遗憾有了被重新书写的可能。',
    free: true,
    featured: false,
  },
];

export const editorPicks = [
  {
    title: '本季度最值得二刷的硬科幻',
    desc: '《星海回响》把宏大设定交还给具体的人，用克制的情绪完成了一次深空回望。',
    tag: '深度影评',
  },
  {
    title: '古装悬疑的新解法',
    desc: '《长安夜行录》用密集的案件节奏与考究的服化道，撑起了长篇剧集的信息量。',
    tag: '剧集观察',
  },
  {
    title: '一间小馆子，半部人间烟火',
    desc: '《深夜食光》以单元故事串联，每一集都能独立成立，适合深夜下饭。',
    tag: '下饭推荐',
  },
];

export const rankings = [
  { rank: 1, title: '星海回响', genre: '科幻 / 冒险', year: '2025', rating: '9.1', note: '年度评分最高，太空题材天花板' },
  { rank: 2, title: '无声证人', genre: '悬疑 / 犯罪', year: '2025', rating: '8.9', note: '法庭推理，反转层层递进' },
  { rank: 3, title: '长安夜行录', genre: '古装 / 悬疑', year: '2025', rating: '8.9', note: '长篇探案，群像扎实' },
  { rank: 4, title: '山海奇缘', genre: '动画 / 奇幻', year: '2025', rating: '8.8', note: '国风动画，视觉与故事双在线' },
  { rank: 5, title: '龙脊山下', genre: '历史 / 战争', year: '2025', rating: '8.7', note: '史诗气质，场面调度出色' },
  { rank: 6, title: '归途列车', genre: '剧情 / 家庭', year: '2024', rating: '8.7', note: '小成本公路片，情感真挚' },
  { rank: 7, title: '记忆碎片铺', genre: '科幻 / 剧情', year: '2025', rating: '8.6', note: '软科幻外壳，记忆隐喻动人' },
  { rank: 8, title: '雾都追踪', genre: '犯罪 / 推理', year: '2024', rating: '8.6', note: '冷峻节奏，双线叙事清晰' },
  { rank: 9, title: '幻夜歌剧院', genre: '奇幻 / 悬疑', year: '2024', rating: '8.6', note: '舞台与现实互文，氛围感极强' },
  { rank: 10, title: '极地防线', genre: '战争 / 群像', year: '2025', rating: '8.5', note: '风雪战场，人物弧光完整' },
];

export const faqs = [
  {
    q: '555电影的片库主要包含哪些内容？',
    a: '片库以电影大全为主体，同时收录电视剧、最新上线的热门新片，以及单独整理的免费电影专区。你可以通过「片库检索」按类型、年份和关键词快速找到目标内容。',
  },
  {
    q: '怎样快速找到自己想看的电影？',
    a: '在首屏搜索框输入片名或关键词，页面会直接跳到片库并完成筛选；也可以先点选类型标签，再切换到「电影」或「剧集」，逐步缩小范围。',
  },
  {
    q: '免费电影专区和其他分区有什么区别？',
    a: '免费专区是把片库中标注为免费的内容单独聚合出来的入口，方便不想逐条翻找的用户一次性浏览。其余分区则按最新、剧集、榜单等维度组织。',
  },
  {
    q: '好看的电影推荐榜单是怎么排序的？',
    a: '口碑榜单综合评分、题材完成度与观众讨论热度进行排序，只作为选片参考。榜单会随片库更新动态调整，建议结合个人口味使用。',
  },
  {
    q: '片库会持续更新吗？',
    a: '会。片库按周更新，最新电影分区会优先收录近期上线的作品，电视剧分区则跟进在播剧集的进度。页面中的数据展示仅用于示例，实际内容以片库更新为准。',
  },
];